import React, { useEffect, useState } from "react";
import Logo from "./Logo";
import { nav } from "../mock";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,box-shadow,backdrop-filter] duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.05)]"
          : "bg-white/60 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-24 md:h-32 flex items-center justify-between">
        <a href="#top" onClick={(e) => { e.preventDefault(); handleClick('#top'); }} className="shrink-0">
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {nav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
              className="relative font-['Montserrat'] font-medium text-[15px] text-neutral-800 hover:text-[#7B3FA7] transition-colors duration-200 group"
            >
              {item.label}
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#7B3FA7] group-hover:w-full transition-[width] duration-300" />
            </a>
          ))}
        </nav>

        <button
          className="md:hidden p-2 rounded-md text-neutral-800 hover:bg-neutral-100 transition-colors"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-neutral-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {nav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                className="font-['Montserrat'] font-medium text-base text-neutral-800 hover:text-[#7B3FA7] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
